// src/components/extraction/CurrencyInput.jsx
// Zahlen-Eingabefeld mit deutschem Format (Komma als Dezimaltrennzeichen). Meldet der
// Elternkomponente bei jeder Eingabe sofort den geparsten Zahlenwert (oder null), formatiert die
// Anzeige aber erst beim Verlassen des Feldes (onBlur) hübsch (z.B. "1.234,50"). Nutzt
// formatCurrency() auch für die Initialanzeige (bevor das Feld fokussiert wurde) - sonst würde
// dort nur der Punkt durch ein Komma ersetzt, ohne auf 2 Nachkommastellen aufzufüllen
// (z.B. "17.1" -> "17,1" statt "17,10").
import React, { useEffect, useState } from 'react'
import { formatCurrency, parseGermanNumber } from './formatters'

function zuEditierbaremText (value) {
  if (value === null || value === undefined || value === '') return ''
  return formatCurrency(value)
}

function CurrencyInput ({ value, onChange }) {
  const [fokussiert, setFokussiert] = useState(false)
  const [entwurf, setEntwurf] = useState(() => zuEditierbaremText(value))

  useEffect(() => {
    if (!fokussiert) setEntwurf(zuEditierbaremText(value))
  }, [value, fokussiert])

  const handleChange = e => {
    const text = e.target.value
    setEntwurf(text)
    onChange(parseGermanNumber(text))
  }

  const handleBlur = () => {
    setFokussiert(false)
    const parsed = parseGermanNumber(entwurf)
    setEntwurf(parsed === null ? '' : formatCurrency(parsed))
  }

  return (
    <input
      type='text'
      inputMode='decimal'
      value={entwurf}
      onFocus={() => setFokussiert(true)}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}

export default CurrencyInput
